import type { VacationSegment, SegmentDecision, VacationRequest } from './vacation.types';

export interface EffectiveSegment extends VacationSegment {
	isApproved: boolean;
}

export function getEffectiveSegmentDates(
	segment: VacationSegment,
	decision: SegmentDecision | undefined
): { startDate: string; endDate: string } {
	if (!decision || decision.status !== 'Approved') {
		return { startDate: segment.startDate, endDate: segment.endDate };
	}

	return {
		startDate: decision.startDate ?? segment.startDate,
		endDate: decision.endDate ?? segment.endDate,
	};
}

export function getApprovedSegments(request: VacationRequest): EffectiveSegment[] {
	const decisions = request.dpSegmentDecisions ?? {};

	return request.segments
		.map(segment => {
			const decision = decisions[String(segment.order)];
			if (decision?.status === 'Rejected') {
				return null;
			}

			const effectiveDates = getEffectiveSegmentDates(segment, decision);
			return {
				...segment,
				startDate: effectiveDates.startDate,
				endDate: effectiveDates.endDate,
				isApproved: decision?.status === 'Approved' || !decision,
			};
		})
		.filter((s): s is EffectiveSegment => s !== null);
}
